import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Loading } from 'react-simple-chatbot'
import { ENDPOINT } from '../../utils'
import axios from 'axios'

export class BunkeyBotUserExists extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      result: '',
      trigger: false
    }
  }


  componentDidMount() {
    const { token, steps } = this.props

    axios.post(`${ENDPOINT}users/validateEmail`, {
      token: token,
      email: steps.support3.value
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({
          loading: false,
          result: resp.data.existingUser
            ? 'exists'
            : 'notFound'
        }, () => this.triggetNext())
      } else {
        this.setState({
          loading: false,
          result: 'notFound'
        })
      }
    }).catch(err => {
      this.setState({
        loading: false,
        result: 'notFound'
      })
    })
  }

  triggetNext = () => {
    const { result } = this.state
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep({
        id: 'support4',
        value: result,
      })
    })
  }

  render() {
    const { loading, result } = this.state
    return (<div>
      {loading && <Loading />}
      {!loading && result === 'exists' && <React.Fragment>
        <span>Si tienes una cuenta activa, para recuperar tu contraseña haz click en Login => ¿Olvidaste tu contraseña?</span>
      </React.Fragment>}
      {!loading && result === 'notFound' && <React.Fragment>
        <span>No tienes cuenta activa en Bunkey =(</span>
      </React.Fragment>}
    </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.public.token
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(BunkeyBotUserExists)))